import React from "react";
import StepperLayout from "../components/AddDriver/StepperLayout";

export default function AddDriver() {
  return <StepperLayout />;
}
